import { render, staticRenderFns } from "./ResumeTemp4.vue?vue&type=template&id=78b90f4a&scoped=true&"
import script from "./ResumeTemp4.vue?vue&type=script&lang=js&"
export * from "./ResumeTemp4.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTemp4.vue?vue&type=style&index=0&id=78b90f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b90f4a",
  null
  
)

export default component.exports